import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Supplier, LoginUser, Report,  Role, CostCenter } from '../../_models';
import { GlobalDataService } from '../../_shared';
import { ReportService } from '../../_services';
import * as XLSX from 'xlsx'; 
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-vowd-report',
  templateUrl: './vowd-report.component.html',
  styleUrls: ['./vowd-report.component.css']
})
export class VowdReportComponent implements OnInit {
  config: any;
  suppliersResult: Supplier[] = [];
  CostCentersResult: CostCenter[] = [];
 
  objectAccountsResult: string[] = [];
  getMonths: string[] = [];
  getYrs : string[]=[];
  user: LoginUser = new LoginUser;
  SupplierAB!: string | null;
  ObjectAccount = '';  
  Area!: string | null;
  Department!: string | null;
  Department1: any;
  Year = '';  
  Month='';
  rptData = new Report();
  vowdResult: any[] = [];
  arrayList: Array<string> = [];
  arrayListArea: Array<string> = [];
  arrayListDepartment: Array<string> = [];
  arrayListAreaDistinct: Array<string> = [];
  arrayListDepartmentDistinct: Array<string> = [];
  vowdTotal:number=0;
  p:any;
  @ViewChild('TABLE', { static: false })
  TABLE!: ElementRef;  

  constructor(private gd : GlobalDataService,
  private reportService  : ReportService,) { }

  ngOnInit() {
    this.user = this.gd.getUserData();
    this.getSuppliers();
    this.getObjectAccount();
    this.getCenterData();
    this.getAcurlYr();
    this.getMonths = this.gd.monthNames;
  }
  
  getSuppliers()
  {
    this.suppliersResult= this.gd.getSupplierData();
    this.arrayList = this.suppliersResult.map(sup => sup.SupplierAB.toString().trim() +"-" +sup.SupplierName.toString().trim()); 
   
  }

  searchSupplier = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayList.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )
  
  getObjectAccount()
  {
    this.objectAccountsResult=this.gd.getAccountData();
  
  }

  searchObjectAcnt = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.objectAccountsResult.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  getCenterData()
  {
    this.CostCentersResult= this.gd.getCostCenterData();
    this.arrayListArea = this.CostCentersResult.map(cost => cost.Area_CODE +"-" +cost.Area_description); 
    this.arrayListDepartment = this.CostCentersResult.map(cost =>cost.Division); 
    this.arrayListAreaDistinct = this.arrayListArea.filter((n, i) => this.arrayListArea.indexOf(n) === i);
    this.arrayListDepartmentDistinct = this.arrayListDepartment.filter((n, i) => this.arrayListDepartment.indexOf(n) === i);
   
  }

  searchArea = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListAreaDistinct.filter(v => v!=null && v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

  searchDepartment = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => term.length < 2 ? []
      : this.arrayListDepartmentDistinct.filter(v => v!=null && v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )
 
  getAcurlYr()
  {
    
    for (var i = 0; i <= 20; i++) {
      this.getYrs.push(((new Date().getFullYear()) - i).toString());
    }
  }

  

  getVOWD()
  {
    this.rptData.supplierAB=(this.SupplierAB==null || this.SupplierAB.trim()=='')?0: parseInt(this.SupplierAB.split('-')[0]);
    this.rptData.objectAccount=this.ObjectAccount.split('-')[0];
    this.rptData.area=(this.Area==null || this.Area.trim()=='')?'':this.Area.split('-')[0];
    this.rptData.department=(this.Department==null || this.Department.trim()=='')?'':this.Department;
    this.rptData.year=this.Year;
    this.rptData.Month = this.Month;
    this.rptData.ProvisionalId = this.user.Role ==Role.Admin||this.user.Role==Role.ReadOnly ?"":this.user.ProvisioningID;
    this.reportService.getOpexAccrualReport(this.rptData).subscribe(data=>{
      if(data !=null)
      {
        this.vowdTotal=0;
      this.vowdResult = data;
      
      for (let i=0;i<this.vowdResult.length;i++)
      {
        this.vowdResult[i].ObjDescr = this.objectAccountsResult.filter(t=>t.split('-')[0].trim()== this.vowdResult[i].ObjectAccount.trim())[0];
       
        this.vowdTotal=this.vowdTotal + this.vowdResult[i].VOWDAmount;
      }
      this.config = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.vowdResult.length
      };
      }
    });
  }

  ExportTOExcel() {  
     
 
      var reportGrid = document.getElementById("reportGrid_all");
      var wb: XLSX.WorkBook = XLSX.utils.book_new();
      let ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(reportGrid);
      wb.SheetNames.push("Sheet1");
      wb.Sheets["Sheet1"] = ws;
  
      /* save to file */
      XLSX.writeFile(wb, 'VOWD' + new Date().toDateString() + '_' + new Date().getTime().toString() + '.xlsx');
  } 
  
  pageChanged(event: any){
    this.config.currentPage = event;
  }
}
